const LeftArrow = (props: object) => (
  <svg viewBox="0 0 514 342" {...props}>
    <path d="M4.12187 178.438L164.056 338.504C168.222 342.673 174.972 342.675 179.139 338.51C183.308 334.345 183.311 327.595 179.146 323.427L37.4116 181.577L502.329 181.767C508.225 181.77 512.998 177.001 513 171.105C513.002 165.209 508.233 160.436 502.337 160.433L37.4203 160.243L179.27 18.5101C183.439 14.3448 183.442 7.59482 179.277 3.42712C178.288 2.43469 177.112 1.64743 175.818 1.11061C174.524 0.57379 173.137 0.29799 171.736 0.299032C169.007 0.297914 166.277 1.3388 164.193 3.42094L4.12703 163.355C-0.0406709 167.52 -0.0434272 174.27 4.12187 178.438V178.438Z" />
  </svg>
)

export default LeftArrow
